import React from 'react';
import { PERFORMANCE_LEVEL, LABEL } from '../../../../../constants/shared/TrcConstants';
import { ASTERISK } from '../../../../../constants/shared/CellConstants';
import { TRC_DESCRIPTION_MAP } from '../../legendConstants';
import { TITLE } from '../../../../../constants/shared/CommonConstants';
import { getPerformanceLevelAbbr } from '../../../../../utils/shared/trcUtils';
import { generateReactKey } from '../../../../../utils/shared/commonUtils';

const { INDEPENDENT } = PERFORMANCE_LEVEL;
const { N_LABEL } = LABEL;
const { ABOVE_TITLE } = TITLE;

const TrcSection = () => (
    <div className="section long-section">
        <h3 className="section-name">TRC Scores</h3>
        <div className="wrap">
            <div className="blue-box">
                <div className="top-abbreviation-ps">{N_LABEL}</div>
                <div className="top-abbreviation-ps-level">
                    Genre <span />
                </div>
                <div className="reading-level">
                    Reading Level <span />{' '}
                </div>
                <div className="top-abbreviation">
                    {`>Z`} <span /> {getPerformanceLevelAbbr(INDEPENDENT)}
                </div>
                <div className="top-abbreviation-ind-level">
                    <span className="first-line" />
                    <span className="second-line" /> Book <br />
                    Performance
                </div>
                <div className="asterisk-sign">{ASTERISK}</div>
                <div className="legend-interp">{ABOVE_TITLE}</div>
            </div>
        </div>
        {TRC_DESCRIPTION_MAP.map(({ firstAbbr, firstTitle, secondAbbr, secondTitle }, index) => (
            <div className="wrap" key={generateReactKey(index)}>
                <span className="abbreviation">{firstAbbr}</span>
                <div className="description">{firstTitle}</div>
                {!!secondAbbr && !!secondTitle && (
                    <div className="second">
                        <span className="abbreviation">{secondAbbr}</span>
                        <div className="description">{secondTitle}</div>
                    </div>
                )}
            </div>
        ))}
    </div>
);

export default TrcSection;
